/* v8 ignore start - style-only / SonarQube */ /* NOSONAR */
import { css } from '@lastbrand/web-ui-styled-system/css'

/*
 * DS presentation for the wishlist share section — mirrors the legacy
 * `wishlist-share-section.module.scss` layout (inline share affordance with an
 * absolutely-positioned confirmation toast). Values in px comments refer to the
 * legacy sheet at its 10px root.
 */

/* eslint-disable i18next/no-literal-string -- Panda CSS literal values (spacing tokens, positions); not user-facing copy */

export const shareWrapperCss = css.raw({
  display: { base: 'flex', lg: 'inline-flex' },
  position: { base: 'initial', lg: 'relative' },
  w: { base: 'full', lg: 'auto' },
  justifyContent: { base: 'center', lg: 'flex-start' },
  mt: { base: 'space-10', lg: '0' },
})

export const shareMsgWrapperCss = css.raw({
  position: 'relative',
})

// The error toast escapes the wrapper on mobile so it can center over the full viewport width.
export const shareMsgWrapperErrorCss = css.raw({
  position: { base: 'initial', lg: 'relative' },
})

export const shareMsgCss = css.raw({
  position: 'absolute',
  background: 'black',
  color: 'white',
  borderRadius: '5px',
  fontWeight: 400,
  whiteSpace: 'nowrap',
  transition: 'background-color 1s ease-out, opacity 1s ease-out, z-index 1s ease-out',
  overflow: 'hidden',
  py: 'space-10',
  px: 'space-20',
  opacity: 0,
  zIndex: -1,
  right: 'auto',
  // Mirrors the legacy toast offset (-0.5rem at the legacy 10px root).
  bottom: '-5px',
  left: 'space-16',
})

export const shareMsgShownCss = css.raw({
  opacity: 1,
  zIndex: 1000,
})

export const shareMsgErrorMobileCss = css.raw({
  transform: { base: 'translateX(-50%)', lg: 'none' },
  left: { base: '50%', lg: 'space-16' },
  bottom: { base: 'space-20', lg: '-5px' },
})

// Compact variant (app-install banner present): the share affordance shrinks to a small inline
// control. Mirrors the legacy `.wishlistShareWrapperCompact` (mobile-only fit-content / no top gap).
export const shareWrapperCompactCss = css.raw({
  w: { base: 'fit-content' },
  mt: { base: '0' },
})

// Applied to the share `TextLink`. Non-compact keeps the legacy uppercase treatment; compact drops
// it and mirrors `.wishlistShareBtnCompact` (gray desktop / black mobile, icon trailing on mobile and
// leading on desktop via the row / row-reverse flip).
export const shareLinkUppercaseCss = css.raw({
  textTransform: 'uppercase',
})

export const shareLinkCompactCss = css.raw({
  textTransform: 'none',
  color: { base: 'black', lg: 'gray' },
  flexDirection: { base: 'row', lg: 'row-reverse' },
  gap: { base: '6px', lg: 'space-4' },
  paddingBlock: '0',
  fontSize: '14px',
  lineHeight: '140%',
  // The DS icon defaults to 1em; pin an explicit size (20px mweb / 16px desktop).
  '& svg': {
    width: { base: '20px', lg: '16px' },
    height: { base: '20px', lg: '16px' },
  },
})
/* eslint-enable i18next/no-literal-string */
/* v8 ignore stop */
